import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import imgPlaceholder from '../../assets/img/img-placeholder.png';
import Spinner from '../UI/Spinner';
import PageTitle from '../UI/PageTitle';
import Breadcrumb from '../UI/Breadcrumb';
import { getCustomer, getFoodCategories } from '../../store/actions';
import { WEEKDAYS_MAP } from '../../utils/constants';
import { convertByTimeZone } from '../../utils/utils';


const CustomerInfoRow = props => (
    <li className="py-15">
        <p className="font-sm color-grey50">{ props.label }</p>
        {
            !props.tags ? <p className="color-primary mt-5">{ props.value }</p> :
                <ul className="tags mt-5"> { props.value }</ul>
        }
    </li>
);


class Customer extends Component {

    componentDidMount() {
        const customerId = this.props.match.params.id;
        this.props.getCustomer(customerId);
        this.props.getFoodCategories();
    }

    getFoodCategoryNameById = FoodCategoryId => {
        const { foodCategories } = this.props;
        let name = '';
        for (const foodCategory of foodCategories) {
            if (foodCategory.id === FoodCategoryId) {
                name = foodCategory.name;
                break;
            }
        }
        return name;
    };

    upperCaseFirstLetter = value => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    };

    renderWeekdays = openingHour => {
        return <li key={openingHour.weekday}>{ WEEKDAYS_MAP[openingHour.weekday] }</li>;
    };

    renderTags = foodCategory => (
        <li key={foodCategory}>
            { this.getFoodCategoryNameById(foodCategory) }
        </li>
    );

    render() {
        if (!this.props.customer) return <Spinner />;
        const { customer } = this.props;
        const { restaurant } = customer;
        const openingHours = restaurant.opening_hours;
        const openHoursFrom = convertByTimeZone(openingHours[0] ? openingHours[0].from_hour.substr(0,5) : '', true);
        const openHoursTo = convertByTimeZone(openingHours[0] ? openingHours[0].to_hour.substr(0,5) : '', true);
        const exclusive_ribbon = restaurant.exclusive_ribbon ? 'Yes' : 'No';
        const foodCategories = restaurant.food_categories;
        return (
            <React.Fragment>
                <PageTitle title="Customer Profile" />

                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers list'}]}
                                current="Customer profile"/>
                </div>

                <div className="container box inner-padding mb-15">
                    <div className="box-body">
                        <div className="row justify-between">
                            <div className="col-xs-12">
                                <div className="flex">
                                    <div className="image-upload size-md my-20">
                                        <div className="image">
                                            <img src={ restaurant.image ? restaurant.image : imgPlaceholder }
                                                 alt="placeholder"/>
                                        </div>
                                    </div>
                                    <ul className="ml-50 mt-10 w-700">
                                        <CustomerInfoRow label="Customer Username" value={customer.username}/>
                                        <CustomerInfoRow label="Customer Name" value={restaurant.name}/>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xs-6 pr-70">
                                <ul className="w-700">
                                    <CustomerInfoRow label="Customer ID" value={customer.id}/>
                                    <CustomerInfoRow label="Customer Type"
                                                     value={this.upperCaseFirstLetter(customer.type)}/>
                                    <CustomerInfoRow label="Customer Mobile Number"
                                                     value={restaurant.phone_number}/>

                                    <CustomerInfoRow label="Customer Description"
                                                     value={restaurant.description}/>

                                    <CustomerInfoRow label="Customer Working Hours"
                                                     value={ `${openHoursFrom} - ${openHoursTo}` }/>

                                    <CustomerInfoRow tags
                                                     label="Customer Working Days"
                                                     value={openingHours.map(this.renderWeekdays)}/>

                                    <CustomerInfoRow label="Agreed Radius" value={ restaurant.agreed_radius }/>
                                    <CustomerInfoRow label="Agreed Delivery Fees"
                                                     value={ restaurant.delivery_fee + ' SAR' }/>

                                </ul>
                            </div>
                            <div className="col-xs-6 pl-70">
                                <ul className="w-700">
                                    <CustomerInfoRow label="User Share of Delivery Fees"
                                                     value={restaurant.user_share_delivery_fee + ' SAR'}/>

                                    <CustomerInfoRow label="Agreed Percentage of Sales"
                                                     value={restaurant.percentage_sales}/>

                                    <CustomerInfoRow label="Minimum Order" value={restaurant.minimum_order}/>
                                    <CustomerInfoRow label="Maximum Order" value={restaurant.threshold}/>
                                    <CustomerInfoRow label="Part time Driver Fees"
                                                     value={restaurant.part_time_driver_fee}/>

                                    <CustomerInfoRow label="Relationship Manager Name"
                                                     value={customer.relationship_manager_name}/>

                                    <CustomerInfoRow label="Relationship Manager Mobile Number"
                                                     value={customer.relationship_manager_phone_number}/>

                                    <CustomerInfoRow label="Exclusive to Foodna Ribbon"
                                                     value={exclusive_ribbon}/>

                                    <CustomerInfoRow label="Required Delivery Car Type"
                                                     value={this.upperCaseFirstLetter(restaurant.delivery_car_type)}/>

                                    { this.props.foodCategories && <CustomerInfoRow tags
                                                                                    label="Customer tag"
                                                                                    value={foodCategories.map(this.renderTags)}/> }

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="box-meta">
                        <div className="text-right">
                            <Link to={ `/customers/${this.props.match.params.id}/edit` }
                                  className="btn filled primary min-120">
                                <i className="fa fa-pencil font-sm mr-10"></i>
                                Edit
                            </Link>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        foodCategories: state.customer.foodCategories,
        customer: state.customer.customer
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getFoodCategories: () => dispatch( getFoodCategories() ),
        getCustomer: id => dispatch( getCustomer(id) )
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( Customer );



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/Customer.js